import React, {useEffect, useState} from 'react';
import {Col} from "react-bootstrap";
import GwInfo from "./GwInfo";
import GwDetail from "./GwDetail";
import {getFcltyDevicesGateway} from "../../api/apiClient";

const GwStatusInfo = ({
                        propType,
                        propName,
                        propFcltyID
                      }) => {

  const [info, setInfo] = useState({});
  const [status, setStatus] = useState({});

  const updateGatewayInfo = () => {
    getFcltyDevicesGateway(propFcltyID).then(response => {
      if (response.data.data !== undefined) {
        setInfo(response.data.data.info);
        setStatus(response.data.data.status);
      }
    });
  };

  useEffect(() => {
    updateGatewayInfo();
  }, []);

  return (
      <>
        <Col md={4} className={'info-container py-2'}>
          <GwInfo
              propType={propType}
              propName={propName}
              propInfo={info}
          />
        </Col>
        <Col md={8} className={'info-container py-2'}>
          <GwDetail
              propType={propType}
              propName={propName}
              propStatus={status}
          />
        </Col>
      </>
  );
};

export default GwStatusInfo;
